import { createRef } from 'react'
import { withUIContext, withDataContext } from 'context'
import { ButtonSimple, Text, Icon } from 'components/common'
import { Form, Input } from 'antd'

const SubmitReportPopup = ({ closePopup, ...props }) => {

    const inputRef = createRef()

    const report = () => {
        let data = {
            url: process.env.NEXT_PUBLIC_APP_URL + props.popupProps.url,
            title: props.popupProps.title,
            text: inputRef.current.resizableTextArea.textArea.value,
        }

        if (data.text.length > 0) {
            return props.report(data).then(() => {
                closePopup()
            })
        }
    }

    return (
        <div className='submit-report-popup flexBoxColumn'>
            <Icon onClick={closePopup} className='op-close' />
            <Text tag='p' className='PopSemi h11' text='Submit Report' />
            <Text tag='h5' className='text PopReg h5' text='Please explain below the reason behind reporting.' />
            <Form.Item>
                <Input.TextArea ref={inputRef} rows={6} className="input-text" placeholder={'Add report'} />
            </Form.Item>
            <div className='buttons flexBox justifyEnd'>
                <ButtonSimple onClick={report} text='Report' />
            </div>
        </div>
    )
}

export default withUIContext(withDataContext(SubmitReportPopup, ['report']), ['closePopup', 'popupProps']);
